import React, { useState, useEffect } from 'react';
import styles from '../../css/ModalDetail.module.css';
import {
	RenderAfterNavermapsLoaded,
	NaverMap,
	Polygon,
	Circle
  } from 'react-naver-maps';

import {GrFormNextLink, GrFormPreviousLink} from 'react-icons/gr';

import Heat from '../../component/ChartHeat';
import Line from '../../component/ChartsLine';
import Line2 from '../../component/ChartsLine2';
import Column from '../../component/ChartsColumn';
import Column2 from '../../component/ChartsColumn2';
import Column3 from '../../component/ChartsColumn3';
import Column4 from '../../component/ChartsColumn4';
import Column5 from '../../component/ChartsColumn5';
import Column6 from '../../component/ChartsColumn6';
import Pie from '../../component/ChartsPie';
import Pie2 from '../../component/ChartsPie2';
import Pie3 from '../../component/ChartsPie3';
import PieByFranch from '../../component/ChartsPieByFranch';
import ChartTreemap from '../../component/ChartTreemap';
import ColumnLine2 from '../../component/ChartColumnLine2';
import Area from '../../component/ChartStackedArea';
import ChartHistogram from '../../component/ChartHistogram';

export default function ModalDetail({
	state,
	setState,
	modal,
	setModal,
	modalPolygonCenter,
	modalPolygonPath,
	selectedPolygon,
	modalPolygonArea,
	areaInfo
}){
	const [busMarkerData, setBusMarkerData] = useState([]);
	const [subwayMarkerData, setSubwayMarkerData] = useState([]);
	const [bikeMarkerData, setBikeMarkerData] = useState([]);
	const [itemData, setItemData] = useState([]);
	const [open, setOpenData] = useState([]);
	const [franchDetail, setFranchDetail] = useState([]);
	const [customerPayment, setCustomerPayment] = useState([]);

	const [bagic, setBagic] = useState(true);
	const [franchise, setFranchise] = useState(false);
	const [payment, setPayment] = useState(false);
	const [customer, setCustomer] = useState(false);
	const [chekcedInputs,setCheckInputs] = useState([]);

	const [year, setYear] = useState('2021');
	const [commCode, setCommCode] = useState('');
	const [commName, setCommName] = useState('');

	const [zoom, setZoom] = useState(modalPolygonArea);
	const [showPage, setShowPage] = useState(true);

	useEffect(() => {
		let data = {}
		data['cluster_id'] = selectedPolygon;
		data['year'] = year;

		(async () => {
			await fetch("/api/getClusterDetailData", {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({ data })
			})
			.then(res => {
				return res.json()
			})
			.then(data => {
				setItemData(data);
				setCommName(" [ "+data.same[0][0]+" ]");
				setOpenData(data.open);
				setFranchDetail(data.franch_detail);
				setCustomerPayment(data.customer_payment);
			})
			.catch(error => console.log(error));
		})()
	}, [selectedPolygon, year]);

	const closePopBtn = (e) => {
		setState({...state, toggle: true, containerShow: false})
		setModal({...modal, modalPolygon: false, modalSelect:false});
	}

	const markerSelect = (target) => {	
		let data = {}
		data['cluster_id'] = selectedPolygon;
		data['search'] = target;
		data['year'] = year;

		fetch("/api/getClusterMarkerData", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ data })
		}).then(res => {
			return res.json()
		}).then(data => {
			if (target === 'bus') {
				setBusMarkerData(data)
			} else if (target === 'subway') {
				setSubwayMarkerData(data)
			} else if (target === 'bike') {
				setBikeMarkerData(data)
			}
		}).catch(error => console.log(error))
	}

	useEffect(() => {
		markerSelect('bus');
		markerSelect('subway');
		markerSelect('bike');
	}, [year]);

	const selectOpenData = (name, type) => {	

		if (type == 'same') {
			let data = {}
			data['cluster_id'] = selectedPolygon;
			data['name'] = name;
			data['year'] = year;

			fetch("/api/getFranchOpenData", {
				method: "POST",
				headers: {
				"Content-Type": "application/json",
				},
				body: JSON.stringify({ data })
			}).then(res => {
				return res.json()
			}).then(data => {
				setOpenData(data.open);
				setFranchDetail(data.franch_detail);
				setCustomerPayment(data.customer_payment);
			}).catch(error => console.log(error))
		} else if (type == 'franch_pay') {
			let data = {}
			data['cluster_id'] = selectedPolygon;
			data['name'] = name;
			data['year'] = year;

			fetch("/api/getFranchPayData", {
				method: "POST",
				headers: {
				"Content-Type": "application/json",
				},
				body: JSON.stringify({ data })
			}).then(res => {
				return res.json()
			}).then(data => {
				setFranchDetail(data.franch_detail);
			}).catch(error => console.log(error))
		}
	}

	const contentChange = (e) => {
		setBagic(false);
		setFranchise(false);
		setPayment(false);
		setCustomer(false);

		if(e.target.checked){
			chekcedInputs.push(e.target.value)
			setCheckInputs([...new Set(chekcedInputs)]);

			if (chekcedInputs.length == 3) {
				setBagic(true);
			} else {
				chekcedInputs.forEach(function(item, index) {
					if (item == 'franchise') {
						setFranchise(true);
					} else if (item == 'payment') {
						setPayment(true);
					} else if (item == 'customer') {
						setCustomer(true);
					}
				}); 
			}
		}else{
			let tmpInputs = chekcedInputs.filter((el) => el !== e.target.value)
			setCheckInputs(tmpInputs);
			
			if (tmpInputs.length == 0) {
				setBagic(true);
			} else {
				tmpInputs.forEach(function(item, index) {
					if (item == 'franchise') {
						setFranchise(true);
					} else if (item == 'payment') {
						setPayment(true);
					} else if (item == 'customer') {
						setCustomer(true);
					}
				}); 
			}
		}
	}

	const setCircleSize = (idx) => {	
		let size = 10;
		if (idx == 0) {
			size = 130;
		} else if (idx == 1) {
			size = 120;
		} else if (idx == 2) {
			size = 110;
		} else if (idx == 3) {
			size = 100;
		} else if (idx == 4) {
			size = 90;
		} else if (idx == 5) {
			size = 80;
		} else if (idx == 6) {
			size = 70;
		} else if (idx == 7) {
			size = 60;
		} else if (idx == 8) {
			size = 50;
		} else if (idx == 9) {
			size = 40;
		}

		return size;
	}
	
	const setCircleColor = (code) => {	
		let color = '';
		if (code == 'bus') {
		  color = '#FF0000';
		} else if (code == 'subway') {
		  color = '#FFA500';
		} else if (code == 'bike') {
		  color = '#0000FF';
		} else if (code == 'N') {
		  color = '#008000';
		} else if (code == 'O') {
		  color = '#0000FF';
		} else if (code == 'P') {
		  color = '#000080';
		} else if (code == 'Q') {
		  color = '#800080';
		} else if (code == 'R') {
		  color = '#000000';
		} else if (code == 'S') {
		  color = '#FFFFFF';
		}
	
			return color;
	}

	const yearChange = (e) => {	
		setYear(e.target.value);
	}

	const nextPage = (e) => {	
		setShowPage(false);
	}

	const prevPage = (e) => {	
		setShowPage(true);
	}

	return(
		<div className={styles.wrap}>
			<div className={styles.container}>
				<div className={styles.titleArea}>
					<h1 dangerouslySetInnerHTML={{ __html: areaInfo }}></h1>
					<div className={styles.contentAreaMenu}>
						<div className={styles.contentTitle}>

							<select onChange={yearChange}>
								<option value='2021' id='2021'>2021</option>
								<option value='2020' id='2020'>2020</option>
								<option value='2019' id='2019'>2019</option>
							</select>
						</div>
						{/* <div className={styles.toggleSelect}>
							<ul>
								<li key='franchise'>
									<input type='checkbox'
										name='gu'
										className='radioSel'
										value='franchise'
										id='franchise'
										style={{display: 'none'}}
										onChange={contentChange}
									/>
									<label htmlFor='franchise' className='radioSel'>
										업종
									</label>
								</li>
								<li key='payment'>
									<input type='checkbox'
										name='gu'
										className='radioSel'
										value='payment'
										id='payment'
										style={{display: 'none'}}
										onChange={contentChange}
									/>
									<label htmlFor='payment' className='radioSel'>
										매출
									</label>
								</li>
								<li key='customer'>
									<input type='checkbox'
										name='gu'
										className='radioSel'
										value='customer'
										id='customer'
										onChange={contentChange}
									/>
									<label htmlFor='customer' className='radioSel'>
										이용고객
									</label>
								</li>
							</ul>
						</div> */}
						{showPage &&
							<button onClick={nextPage} className={styles.pageBtn} type='button'>
								<GrFormNextLink />
							</button>
						}
						{!showPage &&
							<button onClick={prevPage} className={styles.pageBtn} type='button'>
								<GrFormPreviousLink/>
							</button>
						}
					</div>
					<button type='button' onClick={(e) => closePopBtn(e)} className={styles.closeBtn}>
						<img src='img/icon_close.png' alt='close btn' />
					</button>
				</div>
				<div className={styles.contentArea}>
					<div className={styles.mapArea}>
						<RenderAfterNavermapsLoaded
							ncpClientId='frtk0d2cey'
							error={<p>Maps Load Error</p>}
						>
							<NaverMap
								id={'cluster_map'}
								mapDivId={"maps-getting-started-uncontrolled"}
								style={{
									width: '100%',
									height: '100%',
									borderTop: 'transparent',
									borderRadius: '10px',
									border: '1px solid #ccc'
								}}
								center={modalPolygonCenter}
								zoom={zoom}
								draggable={true}
								scrollWheel={true}
							>
								<div className={styles.colorNotice}>
									<ul>
										<li><span />버스</li>
										<li><span />지하철</li>
										<li><span />자전거</li>
									</ul>
								</div>
								<Polygon
									fillColor={'red'}
									fillOpacity={0.2}
									id={'pop_polygon'}
									strokeColor={'red'}
									strokeWeight={2}
									paths={modalPolygonPath}
								/>

								{busMarkerData.map((item, idx) => (
									<Circle
										key={'bus-' + idx}
										center={{ lat: item.lat, lng: item.lon }} // Circle의 중심 좌표
										radius={setCircleSize(idx)} // Circle의 반지름
										fillColor={setCircleColor('bus')} // Circle 내부 색상
										fillOpacity={0.6} // Circle 내부 색상의 투명도
										strokeColor={'black'} // Circle 외곽선 색상
										strokeOpacity={0.5} // Circle 외곽선 색상의 투명도
										strokeWeight={1} // Circle 외곽선 두께
									/>
								))}
								{subwayMarkerData.map((item, idx) => (
									<Circle
										key={'subway-' + idx}
										center={{ lat: item.lat, lng: item.lon }} // Circle의 중심 좌표
										radius={setCircleSize(idx)} // Circle의 반지름
										fillColor={setCircleColor('subway')} // Circle 내부 색상
										fillOpacity={0.6} // Circle 내부 색상의 투명도
										strokeColor={'black'} // Circle 외곽선 색상
										strokeOpacity={0.5} // Circle 외곽선 색상의 투명도
										strokeWeight={1} // Circle 외곽선 두께
									/>
								))}
								{bikeMarkerData.map((item, idx) => (
									<Circle
										key={'bike-' + idx}
										center={{ lat: item.lat, lng: item.lon }} // Circle의 중심 좌표
										radius={setCircleSize(idx)} // Circle의 반지름
										fillColor={setCircleColor('bike')} // Circle 내부 색상
										fillOpacity={0.6} // Circle 내부 색상의 투명도
										strokeColor={'black'} // Circle 외곽선 색상
										strokeOpacity={0.5} // Circle 외곽선 색상의 투명도
										strokeWeight={1} // Circle 외곽선 두께
									/>
								))}
							</NaverMap>
						</RenderAfterNavermapsLoaded>
					</div>
					{showPage && 
						<div className={styles.contentAreaCenter}>
							<div style={{ display: 'flex', justifyContent: 'space-between', height: '50%' }}>
								{bagic && 
									<>
										<div className={`${styles.graphArea} ${styles.normalGraph}`}>
											<PieByFranch chartData={itemData.same} title={'업종별 분표율'} selectOpenData={selectOpenData} setCommName={setCommName} type={'same'} />
										</div>
										<div className={`${styles.graphArea} ${styles.normalGraph}`}>
											<Pie3 chartData={itemData.franch_pay} title={'업종별 매출 분표율'} />
										</div>
										<div className={`${styles.graphArea} ${styles.normalGraph}`}>
											<Column4 chartData={franchDetail} title={'업종 상세별 매출'+commName} />
										</div>
										<div className={`${styles.graphArea} ${styles.normalGraph}`}>
											<Pie2 chartData={open} title={'업종 생존율'+commName} />
										</div>
									</>
								}
							</div>
							<div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-between', height: '50%' }}>
								{bagic && 
									<>
										<div className={`${styles.graphArea} ${styles.middleGraph}`} >
											<Heat chartData={itemData.corr} title={'유동인구에 따른 업종 매출 상관관계'} />
										</div>
										<div className={`${styles.graphArea} ${styles.middleGraph}`}>
											<Column6 chartData={customerPayment} title={'시간대별 유동인구 매출'+commName} />
										</div>
										<div className={`${styles.graphArea} ${styles.middleGraph}`}>
											<ChartHistogram chartData={itemData.distance} title={'거리차별 유동인구'} />
										</div>
									</>
								}
							</div>
						</div>
					}
					{!showPage && 
						<div className={styles.contentAreaCenter}>
							<div style={{ display: 'flex', justifyContent: 'space-between', height: '50%' }}>
								<div className={`${styles.graphArea} ${styles.normalGraph}`}>
									<Column2 chartData={itemData.age} title={'연령별 유동인구'} />
								</div>
								<div className={`${styles.graphArea} ${styles.normalGraph}`}>
									<Line2 chartData={itemData.omega} title={'업종 TOP5 년도별 회복탄력성'} />
								</div>
								<div className={`${styles.graphArea} ${styles.normalGraph}`} >
									<ChartTreemap chartData={itemData.tree} title={'업종별 상점 수'} />
								</div>
								<div className={`${styles.graphArea} ${styles.normalGraph}`}>
									<Pie2 chartData={itemData.gender} title={'성별 유동인구'} />
								</div>
							</div>
							<div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-between', height: '50%' }}>
								<div className={`${styles.graphArea} ${styles.mediumGraph}`}>
									<Area chartData={itemData.age_payment} title={'연도별 연령대 매출'} />
								</div>
								<div className={`${styles.graphArea} ${styles.mediumGraph}`}>
									<ColumnLine2 chartData={itemData.time} title={'연도별 시간대 매출'} />
								</div>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	)
}